<script>
    import { factoryStore } from "../store/factories.js";
    import { langTextStore } from "../store/langtexts.js";
    export let variable = null;
    export let showHelp = false;
    export let baseKey = "variable-";
    $: crntHelpTextKeyBase = baseKey + variable.nameKey;
    $: helpTitle = $langTextStore.getText(crntHelpTextKeyBase + "-help-title");
    $: helpShort = $langTextStore.getText(crntHelpTextKeyBase + "-help-short");
    $: helpLong = $langTextStore.getText(crntHelpTextKeyBase + "-help-long");

    $: showSuperHelpLink =
        helpLong && helpLong.includes(" ") && helpLong.length > 50;
    var timer = null;
    var timeTimer = 1000;

    function mousemove() {
        clearTimeout(timer);
    }
    function mouseout() {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
            showHelp = false;
        }, timeTimer);
    }
</script>

<span
    on:mousemove={() => {
        mousemove();
    }}
    on:mouseout={() => {
        mouseout();
    }}
    on:click={() => {
        showHelp = !showHelp;
    }}
    title={window.location.href.indexOf("test=true") > -1
        ? variable.nameKey
        : $langTextStore.getText(crntHelpTextKeyBase + "-help-title")}
    class="ellipsis helpbox-cursor"
    ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-info-circle pt-1"
        viewBox="0 0 16 16"
    >
        <path
            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
        />
        <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
        />
    </svg>
    {@html helpTitle}</span
>
{#if showHelp}
    <div
        class="helpbox"
        on:mousemove={() => {
            mousemove();
        }}
        on:mouseout={() => {
            mouseout();
        }}
    >
        <div class="helpbox-arrow" />
        <div class="helpbox-text">
            {helpShort}
            {#if showSuperHelpLink}
                <div
                    on:click={() => {
                        factoryStore.showSuperHelp(true, helpTitle, helpLong);
                    }}
                    class="mt-0"
                    style="text-decoration:underline;cursor:pointer"
                    onmousedown="return false"
                >
                    {$langTextStore.getText("general-show-more")}
                </div>
            {/if}
        </div>
    </div>
{/if}
